import { LOGOUT } from './types';

export const clearLogin = () => ( {
	type: LOGOUT,
	promise: Promise.resolve()
} );
